(ns bec-core.cljs.views.selection
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.components.input :as input]))

(defn country-selection []
  (let [countries @(rf/subscribe [:countries])]
    [:div.panel-body
     {:style {:height "calc(100vh - 22.5rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       [:tr
        [:th "Select"]
        [:th [:abbr {:title "id"} "identifier"]]
        [:th [:abbr {:title "h"} "hello"]]
        [:th [:abbr {:title "state is cool"} "state"]]
        [:th "date"]
        [:th [:abbr {:title "t"} "time"]]]]
      (into
        [:tbody]
        (map
          (fn [country]
            [:tr
             [:td
              {:style {:padding 0}}
              [input/checkbox
               {:key (first country)
                :id (first country)
                :class "is-rounded"
                :style {:text-align "start"}
                :outer-style {:border-radius 0}
                #_(rf/dispatch
                    [:dispatch-many
                     [[:dispatch [:assoc-in [:venue] (:id (:information (second country)))]]
                      [:dispatch [:select-view :venues {:subview :options}]]]])}]]
             [:td (first country)]
             [:td "hello"]
             [:td "State"]
             [:td "date"]
             [:td "time"]])
          countries))]]))

(defn city-selection []
  (let [cities @(rf/subscribe [:cities])]
    [:div.panel-body
     {:style {:height "calc(100vh - 22.5rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       [:tr
        [:th "Select"]
        [:th [:abbr {:title "id"} "identifier"]]
        [:th [:abbr {:title "h"} "hello"]]
        [:th [:abbr {:title "state is cool"} "state"]]
        [:th "date"]
        [:th [:abbr {:title "t"} "time"]]]]
      (into
        [:tbody]
        (map
          (fn [city]
            [:tr
             [:td
              {:style {:padding 0}}
              [input/checkbox
               {:key (first city)
                :id (first city)
                :class "is-rounded"
                :style {:text-align "start"}
                :outer-style {:border-radius 0}
                #_(rf/dispatch
                    [:dispatch-many
                     [[:dispatch [:assoc-in [:venue] (:id (:information (second country)))]]
                      [:dispatch [:select-view :venues {:subview :options}]]]])}]]
             [:td (first city)]
             [:td "hello"]
             [:td "State"]
             [:td "date"]
             [:td "time"]])
          cities))]]))

(defn venue-selection []
  (let [venues @(rf/subscribe [:venues])]
    [:div.panel-body
     {:style {:height "calc(100vh - 22.5rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       [:tr
        [:th "Select"]
        [:th [:abbr {:title "id"} "identifier"]]
        [:th [:abbr {:title "h"} "hello"]]
        [:th [:abbr {:title "state is cool"} "state"]]
        [:th "date"]
        [:th [:abbr {:title "t"} "time"]]]]
      (into
        [:tbody]
        (map
          (fn [venue]
            [:tr
             [:td
              {:style {:padding 0}}
              [input/checkbox
               {:key (first venue)
                :id (first venue)
                :class "is-rounded"
                :style {:text-align "start"}
                :outer-style {:border-radius 0}
                #_(rf/dispatch
                    [:dispatch-many
                     [[:dispatch [:assoc-in [:venue] (:id (:information (second country)))]]
                      [:dispatch [:select-view :venues {:subview :options}]]]])}]]
             [:td (first venue)]
             [:td "hello"]
             [:td "State"]
             [:td "date"]
             [:td "time"]])
          venues))]]))

(defn machine-selection []
  (let [machines @(rf/subscribe [:machines])]
    [:div.panel-body
     {:style {:height "calc(100vh - 22.5rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       [:tr
        [:th "Select"]
        [:th [:abbr {:title "id"} "identifier"]]
        [:th [:abbr {:title "h"} "hello"]]
        [:th [:abbr {:title "state is cool"} "state"]]
        [:th "date"]
        [:th [:abbr {:title "t"} "time"]]]]
      (into
        [:tbody]
        (map
          (fn [machine]
            [:tr
             [:td
              {:style {:padding 0}}
              [input/checkbox
               {:key (first machine)
                :id (first machine)
                :class "is-rounded"
                :style {:text-align "start"}
                :outer-style {:border-radius 0}
                #_(rf/dispatch
                    [:dispatch-many
                     [[:dispatch [:assoc-in [:venue] (:id (:information (second country)))]]
                      [:dispatch [:select-view :venues {:subview :options}]]]])}]]
             [:td (first machine)]
             [:td "hello"]
             [:td "State"]
             [:td "date"]
             [:td "time"]])
          machines))]]))

(defn test-selection []
  (let [machines @(rf/subscribe [:machines])]
    [:div.panel-body
     {:style {:height "calc(100vh - 22.5rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       [:tr
        [:th "Select"]
        [:th [:abbr {:title "id"} "identifier"]]
        [:th [:abbr {:title "h"} "hello"]]
        [:th [:abbr {:title "state is cool"} "state"]]
        [:th "date"]
        [:th [:abbr {:title "t"} "time"]]]]
      (into
        [:tbody]
        (map
          (fn [machine]
            [:tr
             [:td
              {:style {:padding 0}}
              [input/checkbox
                   {:key (first machine)
                    :id (first machine)
                    :class "is-rounded"
                    :style {:text-align "start"}
                    :outer-style {:border-radius 0}
                    #_(rf/dispatch
                        [:dispatch-many
                         [[:dispatch [:assoc-in [:venue] (:id (:information (second country)))]]
                          [:dispatch [:select-view :venues {:subview :options}]]]])}]]
             [:td (first machine)]
             [:td "hello"]
             [:td "State"]
             [:td "date"]
             [:td "time"]])
          machines))]]))

(defonce variables (r/atom {:category "country"}))

(defn view []
  (let [accordion @(rf/subscribe [:accordion])
        categories ["country" "city" "venue" "machine" "test"]]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      [:section.section
       [:nav.panel.is-primary
        [:div.panel-heading
         [:p "Select venue"]]
        [:div.panel-block
         {:style {:border-bottom "none"}}
         [:div.control.has-icons-left
          [:input.input
           {:type "text"
            :placeholder "search"}]
          [:span.icon.is-left
           [:i.fas.fa-search
            {:aria-hidden true}]]]]
        [:div.tabs.is-centered.is-boxed
         (into
           [:ul
            {:style {:margin-top "0.5rem"}}]
           (map
             (fn [category]
               [:li
                {:class (when (= (:category @variables) category) "is-active")
                 :style {:position "relative"}}
                [:button.simple-button.is-clickable 
                 {:style {:text-transform "capitalize"}
                  :on-click #(swap! variables assoc :category category)}
                 category]
                (when (= (:category @variables) category)
                  [:p.help.fade-in
                   {:style {:position "absolute"
                            :top "-0.5rem"
                            :right "-0.5rem"
                            :height "1.25rem"
                            :width "1.25rem"
                            :background "var(--blue)"
                            :border-radius "50%"
                            :text-align "center"
                            :display "flex"
                            :justify-content "center"
                            :align-items "center"
                            :margin "0"}}
                   29])])
             categories))]
        (case (:category @variables)
          "country" [country-selection]
          "city" [city-selection]
          "venue" [venue-selection]
          "machine" [machine-selection]
          "test" [test-selection])
        [:div.panel-block
         {:style {:overflow "auto"}}
         [:button.button.is-link.is-outlined.is-fullwidth
          {:style {:transform "unset"
                   :margin "0.25rem 0.5rem"}
           :disabled true}
          "Actions"]
         [:button.button.is-link.is-outlined.is-fullwidth
          {:style {:transform "unset"
                   :margin "0.25rem 0.5rem"}
           :disabled true}
          "Information"]
         [:button.button.is-link.is-outlined.is-fullwidth
          {:style {:transform "unset"
                   :margin "0.25rem 0.5rem"}}
          "Settings"]]]]]]))
